const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const GEAR_DEFINITIONS = [
  { id: 'production', name: 'PRODUCTION' },
  { id: 'training', name: 'TRAINING' },
  { id: 'management', name: 'MANAGEMENT' },
  { id: 'sales', name: 'SALES' },
  { id: 'jobs', name: 'JOBS' },
  { id: 'calendar', name: 'CALENDAR' },
  { id: 'human-resources', name: 'HUMAN RESOURCES' },
  { id: 'customer-care', name: 'CUSTOMER CARE' },
  { id: 'fleet', name: 'FLEET' },
  { id: 'service', name: 'SERVICE' },
  { id: 'engineering', name: 'ENGINEERING' },
];

// Granular tool definitions within each gear
// beta: true = only visible in dev company & platform admin
const TOOL_REGISTRY = {
  production: [
    { id: 'jobs', label: 'Jobs', description: 'Manage jobs, forms & documentation' },
    { id: 'safety', label: 'Safety', description: 'Emergency procedures & protocols' },
    { id: 'vehicle-inspections', label: 'Vehicle Inspections', description: 'Daily vehicle & trailer inspections' },
    { id: 'calendar', label: 'Calendar', description: 'Schedule jobs & manage crew assignments' },
    { id: 'manuals', label: 'Installation Manuals', description: 'Access & manage technical documentation' },
    { id: 'checklists', label: 'Checklists', description: 'Safety protocols & work checklists' },
    { id: 'vendors', label: 'Vendor List', description: 'Manage suppliers & vendors' },
    { id: 'pier-logs', label: 'Pier Logs', description: 'Track pier installation data & progress' },
    { id: 'sump-pump-inspections', label: 'Sump Pump Inspections', description: 'Step-by-step sump pump inspection form' },
    { id: 'septic-as-built', label: 'Septic As Built', description: 'As-built triangulation & elevation tables' },
    { id: 'employees', label: 'Employee Contacts', description: 'Find staff contact information' },
  ],
  sales: [
    { id: 'estimates', label: 'Estimates', description: 'Create & manage estimates' },
    { id: 'invoices', label: 'Invoices', description: 'Create & manage invoices' },
    { id: 'clients', label: 'Clients', description: 'Manage sales clients' },
    { id: 'crm', label: 'CRM', description: 'Customer relationship management' },
    { id: 'notifications', label: 'Notifications', description: 'Sales notifications' },
    { id: 'reports', label: 'Reports', description: 'Sales reports & analytics' },
    { id: 'settings', label: 'Settings', description: 'Sales configuration' },
  ],
  management: [
    { id: 'crew-organizer', label: 'Crew Organizer', description: 'Organize & manage crews' },
    { id: 'passwords', label: 'Passwords', description: 'Credential management (admin only)' },
    { id: 'running-job-summary', label: 'Running Job Summary', description: 'Active job overview (admin only)' },
    { id: 'fleet', label: 'Fleet', description: 'Equipment & vehicle management' },
    { id: 'pay-scale', label: 'Pay Scale', description: 'Pay rates & position management' },
    { id: 'field-forms', label: 'Field Forms', description: 'Field documentation archive' },
    { id: 'performance-metrics', label: 'Performance Metrics', description: 'Job cost vs invoice performance analytics' },
    { id: 'company-contacts', label: 'Company Contacts', description: 'Directory of engineers, inspectors, and external contacts' },
  ],
  'human-resources': [
    { id: 'employees', label: 'Employees', description: 'Employee records & management' },
    { id: 'hr-positions', label: 'Positions', description: 'Position management & evaluations' },
  ],
  engineering: [
    { id: 'push-pier-calculator', label: 'Push Pier Calculator', description: 'Engineering calculations' },
  ],
  'customer-care': [
    { id: 'phone-intake', label: 'Phone Intake', description: 'New phone intake form' },
    { id: 'lead-intake', label: 'Lead Intake', description: 'Lead intake management' },
    { id: 'custom-lead-forms', label: 'Custom Lead Forms', description: 'Build and use company-specific lead forms' },
    { id: 'phone-intake-archive', label: 'Phone Intake Archive', description: 'Archived phone intakes' },
    { id: 'sops', label: 'SOPs', description: 'Standard operating procedures' },
  ],
  training: [],
  fleet: [],
  jobs: [],
  calendar: [],
  service: [],
};

export { BACKEND_URL, API, GEAR_DEFINITIONS, TOOL_REGISTRY };
